const BULLET_LINE_PATTERN = /^(\s*)•\s+/;

/**
 * Convert the bullet paragraphs returned by tile-note generation into Markdown
 * list items so generated notes use the same Lexical structure as authored
 * notes.
 */
export function normalizeGeneratedTileNotes(notes: string): string {
  return notes
    .split('\n')
    .map((line) => line.replace(BULLET_LINE_PATTERN, '$1- '))
    .join('\n');
}
